"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _locales = _interopRequireDefault(require("../../locales"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * useLocalization Hook
 * @param {string} market The market/locale code to retrieve translations for (e.g., 'en', 'es').
 * @returns {Function} A function that takes a translation key and returns the localized string.
 */
function useLocalization(market) {
  const locale = _locales.default[market] || _locales.default['en-US'];
  return key => {
    const value = locale[key];
    return value || key;
  };
}
var _default = useLocalization;
exports.default = _default;